// Notes de la séance (J31, 28/10/2026) : ce que le moniteur prévoit avant la séance et ce qu'il note pendant, dès la
// première leçon. Gardées sur cet appareil, par moniteur et par élève, jusqu'au résumé de la séance qui les reprend ;
// effacées au résumé enregistré et à la déconnexion. Stockage indisponible : rien n'est gardé, rien ne plante.

export interface SessionNotes {
  before: string;
  during: string;
}

const PREFIX = 'permio-moniteur-notes:';
const keyOf = (userId: string, candidateId: string) => `${PREFIX}${userId}:${candidateId}`;

export function readSessionNotes(userId: string | undefined, candidateId: string): SessionNotes {
  const empty = { before: '', during: '' };
  if (!userId) return empty;
  try {
    const raw = localStorage.getItem(keyOf(userId, candidateId));
    const value = raw ? (JSON.parse(raw) as Partial<SessionNotes>) : null;
    return {
      before: typeof value?.before === 'string' ? value.before : '',
      during: typeof value?.during === 'string' ? value.during : '',
    };
  } catch {
    return empty;
  }
}

export function saveSessionNotes(userId: string | undefined, candidateId: string, notes: SessionNotes) {
  if (!userId) return;
  try {
    if (!notes.before.trim() && !notes.during.trim()) localStorage.removeItem(keyOf(userId, candidateId));
    else localStorage.setItem(keyOf(userId, candidateId), JSON.stringify(notes));
  } catch {
    // stockage indisponible : notes gardées à l'écran seulement.
  }
}

export function clearSessionNotes(userId: string | undefined, candidateId: string) {
  saveSessionNotes(userId, candidateId, { before: '', during: '' });
}

/** Déconnexion : les notes de ce moniteur quittent l'appareil. */
export function clearAllSessionNotes(userId: string | undefined) {
  if (!userId) return;
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith(`${PREFIX}${userId}:`)) localStorage.removeItem(key);
  } catch {
    // stockage indisponible : rien à effacer.
  }
}
